/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

function toBinaryUtf16LittleEndian(param: string): string {
    let result = '';
    const codeUnits = Uint16Array.from(
            {length: param.length},
            (element, index) => param.charCodeAt(index)
    );
    const charCodes = new Uint8Array(codeUnits.buffer);
    charCodes.forEach((char) => {
        result += String.fromCharCode(char);

    });

    return result;
}

export function toBase64Utf16LittleEndian(param: string): string {
    return param != null ? btoa(toBinaryUtf16LittleEndian(param)) : undefined;
}
